import { createComponent } from '@mtfe/sweet';
import { eventBus, common, createObserve } from '@mtfe/sweet-utils';
import { WelfareCard, componentUtils, Draw, RedBagList } from '@mtfe/sweet-components';

import tpl from './dom.html';
import style from './style.less';
import WaimaiDrawBody from '../WaimaiDrawBody/script';
import InnerPoi from '../common/InnerPoi/script';

import { fetchAllCoupon, fetchOneRedBag } from '../../utils/fetchData';
import { renderPoiInfoG } from '../../utils/renderPoi';
import { useAutoLogin } from '../../utils/index';
import { COUPON_STATUS } from '../../constants/index';
import http from '../../service';

const { debounceByPromise, createUniqueId } = common;
const { getOnClickEventName } = componentUtils;

const couponTitleConfig = {
    Waimai: {
        title: '大额外卖红包',
        subtitle: '部分商家可用',
    },
    Shangou: {
        title: '大额商超券',
        subtitle: '部分商家商品可用',
    },
};

const RedBagComponentReady = (redBagListObj, readyKey) => {
    eventBus.$on(`${readyKey}RedBagComponentReady`, () => {
        const { redBagArrList } = redBagListObj.propsCache;
        const couponDomList = Array.from(
            document.querySelectorAll(`#${redBagListObj.redBagUniqueId} [coupon-monitor-index]`),
        );
        const observeCb = async (err, item) => {
            if (err) {
                return;
            }
            const componentID = RedBagList.describe.getSubComponent('RedBag').getComponentID();
            try {
                const currentIndex = item.target.getAttribute('coupon-monitor-index');
                const { impMonitorUrl } = redBagArrList[currentIndex];
                const url = `${impMonitorUrl}&componentId=${componentID}`;
                await http.gMonitorApi(url);
            } catch (error) {
                console.error('曝光失败', error);
            }
        };
        if (couponDomList.length) {
            createObserve(observeCb, couponDomList);
        }
    });
};

const RedBagComponent = (props = {}) => {
    const { targetStore, couponKey, welfareIndex } = props;
    const { recallBizId, discountData } = targetStore;
    const { redBagList, giftValue } = discountData;
    const RedBagComponentID = createUniqueId();

    if (!redBagList.length) {
        return '';
    }

    redBagList.forEach((poiInfo) => {
        const {
            poiData,
            coupon_amount: couponAmount,
            order_amount_limit: orderAmountLimit,
        } = poiInfo.giftInfo;
        const poiListDom = InnerPoi({ poiData, renderFunc: renderPoiInfoG });
        poiInfo.draw = new Draw(
            WaimaiDrawBody({
                value: couponAmount / 100,
                threshold: orderAmountLimit / 100,
                poiListDom,
                isShangouModule: couponKey === 'Shangou',
            }),
        );
    });

    const onClickRedBagBtnHandler = debounceByPromise(
        useAutoLogin(async (poiInfo) => {
            const { giftInfo, draw } = poiInfo;
            const { gift_id: giftId, poiData } = giftInfo;
            const canReceive = giftInfo.status === COUPON_STATUS.STATUS_NEW;

            if (canReceive) {
                try {
                    await fetchOneRedBag(poiInfo, recallBizId);
                } catch (error) {
                    console.error(error);
                }
            } else {
                if (draw) {
                    draw.onOpenDraw(() => {
                        const onClickEventName = getOnClickEventName(poiData.recallBizId, giftId);
                        eventBus.$emit(onClickEventName);
                    });
                }
            }
        }),
        500,
        true,
    );
    const onClickRedBagReceiveAllHandler = debounceByPromise(
        useAutoLogin(async () => {
            try {
                await fetchAllCoupon(redBagList, recallBizId);
                // eslint-disable-next-line
                redBagListObj.render();
            } catch (error) {
                console.error(error);
            }
        }),
        500,
        true,
    );
    const curCouponConfig = couponTitleConfig[couponKey] || {};
    const redBagListObj = new RedBagList({
        title: curCouponConfig.title || '大额外卖红包',
        subtitle: curCouponConfig.subtitle || '部分商家可用',
        redBagArrList: redBagList,
        onClickBtn: onClickRedBagBtnHandler,
        onClickReceiveAll: onClickRedBagReceiveAllHandler,
    });
    const data = {
        wmRedBagListDom: WelfareCard({
            welfareIndex,
            title: `${giftValue / 100}元大额${couponKey === 'Waimai' ? '红包' : '券'}`,
            innerComponent: redBagListObj.getComponent(),
        }),
        RedBagComponentID,
        redBagArrList: redBagList,
    };
    const events = {};
    RedBagComponentReady(redBagListObj, couponKey);
    return createComponent(tpl, { data, style }, events);
};
export default RedBagComponent;
